import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { FormattedMessage } from 'react-intl';
import ModalBox from '../ModalBox/ModalBox';
import Utility from '../Utility/Utility';
import { AccountProfile } from './AccountProfile';
import { AccountOwner } from './AccountOwner';
import { AccountOptions } from './AccountOptions';
import * as Settings from '../../Settings.js';
import jQuery from 'jquery';
import 'jquery-mask-plugin';
import './AccounTable.css';

const AccounTable = () => {
	const [show, showModal] = useState( false );																//- To show/hide main dialog box
	const [modalSize, setModalSize] = useState( "xl" );															//- Main dialog box size
	const [modalTitle, setModalTitle] = useState( "" );															//- Main dialog box title
	const [tabKey, setTabKey] = useState('profile');

	const [showMsg, showMsgModal] = useState( false );															//- To show/hide dialog box messages
	const [modalMsgSize, setModalMsgSize] = useState( "md" );													//- Dialog box messages
	const [modalMsgTitle, setModalMsgTitle] = useState( "" );													//- Dialog box title

	const submitBtnId 	= "appSubmitBtnDlg";
	const appCloseBtn 	= "appCloseBtnDlg";
	const modalMsgsId 	= "appModalMsgsDlg";
	const modalBodyId 	= "appModalBodyDlg";
	const modalTitleId 	= "appModalTitleDlg";
	const modalBoxId 	= "appDialogBoxDlg";
	const MAX_UPLOAD_FILE_SIZE = 5000000;
	const MAX_UPLOAD_FILE_NAME = 64;

	const Utl = new Utility();
	const language = Utl.getCookie("appLang");
    const acctTable = "AppAccounTable";

	const handleModalExit = () => {                                                                             //- Handle modal dialog box
		showModal( false );                                                                                     //- Set modal dialog box show status
    };

	const handleModalMsgExit = () => {
		showMsgModal( false );
	}

	const onTabSelect = ( key ) => {
		Utl.appLogger( "Tab selected: ", key );
		const tabEvent	= new Event("appTabSelected");
		tabEvent.tabSelected = key;
		setTabKey( key );

		let timerId = setInterval(function() {
			switch( key ) {
				case "profile":
					document.getElementById("cus_bus_name").focus();
					break;
				case "owner":
					document.getElementById("cus_first_name").focus();
					break;
				case "menus":
					break;
				case "options":
					document.getElementById("cus_bus_facebook").focus();
					break;
				default:
					break;
			}
			document.dispatchEvent(tabEvent);
			clearInterval( timerId );
		}, 150);
	}
	/*
	const getFormattedTime = ( elementId ) => {
		let [h, m] = document.getElementById( elementId ).value.split(":");
		let timeIs = ( h === "" ? "" : (h % 12 ? h % 12 : 12) + ":" + m + " " + (h >= 12 ? 'pm' : 'am') );
		Utl.appLogger( "time is: ", timeIs );
		return( timeIs );
	}
	*/
	const validateCustomerForm = ( Utl ) => {
		const reqFields = ["cus_bus_name", "cus_bus_address", "cus_bus_city", "cus_bus_zip", "cus_first_name", "cus_last_name" ];
		let formReady = true;

		for( let ndx = 0; ndx < reqFields.length; ndx++ ) {
			let minSize = ( reqFields[ndx] === "cus_bus_zip" ? 5 : 3 );
			if( document.getElementById( reqFields[ndx] ).value.trim().length < minSize ) {
				formReady = false;
				jQuery( "#" + reqFields[ndx] ).css( "border-color", "var(--bs-form-invalid-border-color)" );
			} else {
				jQuery( "#" + reqFields[ndx] ).css( "border-color", "var(--bs-border-color)" );
			}
		}

		if( Utl.getDigitsOnly( document.getElementById( "cus_bus_phone" ).value ).length < 10 ) {
			formReady = false;
			jQuery( "#cus_bus_phone" ).css( "border-color", "var(--bs-form-invalid-border-color)" );
		} else {
			jQuery( "#cus_bus_phone" ).css( "border-color", "var(--bs-border-color)" );
		}

		if( Utl.getDigitsOnly( document.getElementById( "cus_phone" ).value ).length < 10 ) {
			formReady = false;
			jQuery( "#cus_phone" ).css( "border-color", "var(--bs-form-invalid-border-color)" );
		} else {
			jQuery( "#cus_phone" ).css( "border-color", "var(--bs-border-color)" );
		}

		Utl.appLogger( "Customer data validation: ", formReady );
		return( formReady );
	}

	const setBusinessHours = ( language, Utl ) => {
		Utl.appLogger( "setBusinessHours" );
		const closedTxt 	= ( language === "en" ? "Closed" : "Cerrado" );
		const timeSel = `
		#mon_time_from_label, #mon_time_to_label, 
		#tue_time_from_label, #tue_time_to_label,
		#wed_time_from_label, #wed_time_to_label,
		#thu_time_from_label, #thu_time_to_label,
		#fri_time_from_label, #fri_time_to_label,
		#sat_time_from_label, #sat_time_to_label,
		#sun_time_from_label, #sun_time_to_label
		`;
		const timeFld = `
		#mon_time_from, #mon_time_to, 
		#tue_time_from, #tue_time_to,
		#wed_time_from, #wed_time_to,
		#thu_time_from, #thu_time_to,
		#fri_time_from, #fri_time_to,
		#sat_time_from, #sat_time_to,
		#sun_time_from, #sun_time_to
		`;
		jQuery( timeSel ).html( closedTxt ).removeClass( "d-none" );
		jQuery( timeFld ).addClass( "d-none" );
	}

	const setCarouselImages = ( acctData, imgDir, imgAcctDir ) => {
		jQuery( "#cus_bus_carousel_img_0" ).val( acctData.cus_bus_carousel_img_0 );
		jQuery( "#cus_bus_carousel_img_1" ).val( acctData.cus_bus_carousel_img_1 );
		jQuery( "#cus_bus_carousel_img_2" ).val( acctData.cus_bus_carousel_img_2 );
		jQuery( "#cus_bus_carousel_img_3" ).val( acctData.cus_bus_carousel_img_3 );
		jQuery( "#cus_bus_carousel_img_4" ).val( acctData.cus_bus_carousel_img_4 );
		jQuery( "#cus_bus_carousel_img_5" ).val( acctData.cus_bus_carousel_img_5 );

		/*
		const carousel_img_0 = ( acctData.cus_bus_carousel_img_0 === "" || acctData.cus_bus_carousel_img_0 === null ? imgDir : imgAcctDir + "/" + acctData.cus_bus_carousel_img_0 );
		const carousel_img_1 = ( acctData.cus_bus_carousel_img_1 === "" || acctData.cus_bus_carousel_img_1 === null ? imgDir : imgAcctDir + "/" + acctData.cus_bus_carousel_img_1 );
		const carousel_img_2 = ( acctData.cus_bus_carousel_img_2 === "" || acctData.cus_bus_carousel_img_2 === null ? imgDir : imgAcctDir + "/" + acctData.cus_bus_carousel_img_2 );
		const carousel_img_3 = ( acctData.cus_bus_carousel_img_3 === "" || acctData.cus_bus_carousel_img_3 === null ? imgDir : imgAcctDir + "/" + acctData.cus_bus_carousel_img_3 );
		const carousel_img_4 = ( acctData.cus_bus_carousel_img_4 === "" || acctData.cus_bus_carousel_img_4 === null ? imgDir : imgAcctDir + "/" + acctData.cus_bus_carousel_img_4 );
		const carousel_img_5 = ( acctData.cus_bus_carousel_img_5 === "" || acctData.cus_bus_carousel_img_5 === null ? imgDir : imgAcctDir + "/" + acctData.cus_bus_carousel_img_5 );
		jQuery( "#carousel_img_0" ).attr( "src", carousel_img_0 );
		jQuery( "#carousel_img_1" ).attr( "src", carousel_img_1 );
		jQuery( "#carousel_img_2" ).attr( "src", carousel_img_2 );
		jQuery( "#carousel_img_3" ).attr( "src", carousel_img_3 );
		jQuery( "#carousel_img_4" ).attr( "src", carousel_img_4 );
		jQuery( "#carousel_img_5" ).attr( "src", carousel_img_5 );
		*/
	}

	const showMessageDlg = ( dlgId, dlgSize, dlgTitle, dlgMessage ) => {
		setModalMsgSize( dlgSize );
		setModalMsgTitle( dlgTitle );																			//- Set dialog header title with current language
		showMsgModal( true );

		let timerId = setInterval(function() {                                              					//- Set an interval timer and
			const appDiv = document.getElementById( dlgId );                 									//- get the dialog body div
			if( appDiv !== null ) {
				jQuery( "#" + dlgId ).append( "<div class='text-center'>" +dlgMessage+ "</div>" );
				jQuery( "#" + submitBtnId ).hide();
				document.getElementById( appCloseBtn ).innerHTML = "OK";
				clearInterval(timerId);
			}
		}, 100);

		return( true );
	}



	//let [localDir, setAppDirs] = useState( [] );

	useEffect(() => {
		const localDir = JSON.parse(localStorage.getItem('appDirs'));
		//localDir = JSON.parse(localStorage.getItem('appDirs'));
		//if (localDir) {
		//	setAppDirs(localDir);
		//}
		
		const adminDir = localDir["admin"];
		const menusDir = localDir["menus"];
		const samplDir = localDir["samples"];
		const imageDir = localDir["images"];
		const Utl = new Utility();
		let language = Utl.getCookie("appLang");
		
		Utl.appLogger( "adminDir:", adminDir );
		Utl.appLogger( "menusDir:", menusDir );
		let server = adminDir + "/api/appAgent.php";


		//---------------------------------------------
		//- Show Modal dialog
		//---------------------------------------------
		const setModalDialogBox = () => {
			const readyEvent	= new Event("modalboxready");
			const appStates		= JSON.parse(localStorage.getItem('appStates'));
			const appFood		= JSON.parse(localStorage.getItem('appFood'));

			setModalSize( "xl" );
			setModalTitle( ( language === "en" ? "Account profile" : "Perfil de Cuenta" ) );						//- Set dialog header title with current language
			setTabKey( "profile" );
			showModal( true );

			let timerId = setInterval(function() {                                              					//- Set an interval timer and
				const appTab = document.getElementById( Settings.APP_DLG_ID );
				if( appTab !== null ) {
					const tabProfile 	= ( language === "en" ? "Profile" : "Perfil" );
					const tabOwner 		= ( language === "en" ? "Owner" : "Propietario" );
					const tabMenus 		= ( language === "en" ? "Menus" : "Menús" );
					const tabOptions 	= ( language === "en" ? "Options" : "Opciones" );
					const closedTxt 	= ( language === "en" ? "Closed" : "Cerrado" );

					jQuery( "#appAccountProfile-tab-profile" ).html( '<i class="fas fa-file-contract fa-fw me-2" aria-hidden="true"></i> ' + tabProfile );
					jQuery( "#appAccountProfile-tab-owner" ).html( '<i class="fas fa-user-tie fa-fw me-2" aria-hidden="true"></i> ' + tabOwner );
					jQuery( "#appAccountProfile-tab-menus" ).html( '<i class="fas fa-utensils fa-fw me-2" aria-hidden="true"></i> ' + tabMenus );
					jQuery( "#appAccountProfile-tab-options" ).html( '<i class="fas fa-tasks"></i> ' + tabOptions );

					jQuery( "#appAcctProfileDetails").html( AccountProfile );
					jQuery( "#appAcctOwnerDetails").html( AccountOwner );
					jQuery( "#appAcctOptionsDetails").html( AccountOptions );

					//- Set style images on Options section
					document.getElementById( "appTemplate1" ).setAttribute( "src", adminDir + "/assets/images/samples/style_0.png" );
					document.getElementById( "appTemplate2" ).setAttribute( "src", adminDir + "/assets/images/samples/style_1.png" );
					document.getElementById( "appTemplate3" ).setAttribute( "src", adminDir + "/assets/images/samples/default.png" );
					
					//- Add food types
					for( let food = 0; food < appFood.length; food++ ) {
						jQuery( "#cus_bus_food_type" ).append( jQuery( '<option>', { value: appFood[food].fod_id, text: ( language === "en" ? appFood[food].fod_description_en : appFood[food].fod_description_es ) } ) );
					}

					//- Add states
					const acctState = "CA";
					for( let state = 0; state < appStates.length; state++ ) {
						jQuery( "#cus_bus_state" ).append( jQuery( '<option>', { value: appStates[state].state_id, text: appStates[state].state_name, selected: ( appStates[state].state_id === acctState ? true : false ) } ) );
						jQuery( "#cus_state" ).append( jQuery( '<option>', { value: appStates[state].state_id, text: appStates[state].state_name, selected: ( appStates[state].state_id === acctState ? true : false ) } ) );
					}

					//- Select business hours
					jQuery( "#bus_hours_mon, #bus_hours_tue, #bus_hours_wed, #bus_hours_thu, #bus_hours_fri, #bus_hours_sat, #bus_hours_sun" ).on( "click tap", function( event ) {
						event.stopImmediatePropagation();
						Utl.appLogger( "box checked: ", event );

						const targetBox = event.target.id;
						const timeboxes = { "bus_hours_mon":"mon_time_", 
											"bus_hours_tue":"tue_time_", 
											"bus_hours_wed":"wed_time_", 
											"bus_hours_thu":"thu_time_", 
											"bus_hours_fri":"fri_time_", 
											"bus_hours_sat":"sat_time_", 
											"bus_hours_sun":"sun_time_" };
						const isChecked = document.getElementById( targetBox ).checked;

						document.getElementById( timeboxes[targetBox] + "from" ).setAttribute("disabled", ( isChecked ? false : true ) );
						document.getElementById( timeboxes[targetBox] + "to" ).setAttribute("disabled", ( isChecked ? false : true ) );
						document.getElementById( timeboxes[targetBox] + "from" ).value 	= ( isChecked ? "09:00" : "" );
						document.getElementById( timeboxes[targetBox] + "to" ).value 	= ( isChecked ? "17:00" : "" );

						if( isChecked ) {
							document.getElementById( timeboxes[targetBox] + "from" ).removeAttribute( "disabled" );
							document.getElementById( timeboxes[targetBox] + "to" ).removeAttribute( "disabled" );
							document.getElementById( timeboxes[targetBox] + "from_label" ).classList.add("d-none");
							document.getElementById( timeboxes[targetBox] + "to_label" ).classList.add("d-none");
							document.getElementById( timeboxes[targetBox] + "from" ).classList.remove("d-none");
							document.getElementById( timeboxes[targetBox] + "to" ).classList.remove("d-none");

						} else {
							document.getElementById( timeboxes[targetBox] + "from" ).classList.add("d-none");
							document.getElementById( timeboxes[targetBox] + "to" ).classList.add("d-none");
							document.getElementById( timeboxes[targetBox] + "from_label" ).classList.remove("d-none");
							document.getElementById( timeboxes[targetBox] + "to_label" ).classList.remove("d-none");
							document.getElementById( timeboxes[targetBox] + "from_label" ).innerHTML = closedTxt;
							document.getElementById( timeboxes[targetBox] + "to_label" ).innerHTML = closedTxt;
						}
					});

					//- Select business logo
					const selBtn = document.getElementById( "appSelectLogo" );
					const selImg = document.getElementById( "cus_logo_upload" );

					selBtn.addEventListener(
						"click",
						(e) => {
						if (selImg) {
							selImg.click();
						}
						},
						false,
					);

					selImg.addEventListener(
						"change",
						(e) => {
							Utl.appLogger( "event: ", e );
							const upldFile = document.getElementById( "cus_logo_upload" ).value;
							//const fileOnly = upldFile.substr(upldFile.lastIndexOf("\\") + 1);
							//document.getElementById( "cus_logo" ).value = fileOnly;
							document.getElementById( "cus_logo" ).value = "account_logo.jpg";

							let files = jQuery('#cus_logo_upload')[0].files[0]; 
							Utl.appLogger( "File: ", files );
							
							if( files.size > MAX_UPLOAD_FILE_SIZE || files.name.length > MAX_UPLOAD_FILE_NAME ) {
								const prevLogo = document.getElementById( "cus_logo_saved" ).value;
								document.getElementById( "cus_logo_upload" ).value = "";
								document.getElementById( "cus_logo" ).value = prevLogo;

								const isTooBig = ( files.size > MAX_UPLOAD_FILE_SIZE ? true : false );
								const uploadFileBig = ( language === "en" ? "This file size is too big.  Maximum size is 5 megabytes." : "El tamaño de este archivo es muy grande.  El tamaño máximo es de 5 megabytes." );
								const uploadNameBig = ( language === "en" ? "This file name size is too big.  Maximum file name size is 32 characters." : "El nombre de este archivo es muy grande.  El tamaño máximo del nombre es de 32 bytes." );
								
								const dlgId 		= modalBodyId;
								const dlgSize		= "md";
								const dlgTitle 		= ( language === "en" ? "File too big" : "Archivo muy grande" );
								const dlgMessage 	= ( isTooBig ? uploadFileBig : uploadNameBig );

								Utl.appLogger( ( isTooBig ? "File size of " + files.size : "File name size of " + files.name.length ) + " is too big!" );
								showMessageDlg( dlgId, dlgSize, dlgTitle, dlgMessage );
							}
						},
						false,
					);

					//- Monitor click event on account status radio button options
					jQuery( "#acctStatusActive, #acctStatusInactive, #acctStatusSuspended, #acctStatusUnder" ).on( "click tap", function( event ) {
						event.stopImmediatePropagation();
						Utl.appLogger( "acct status click event: ", event );
						Utl.appLogger( "acct status clicked: ", event.target.id );

						let acctStatus = document.getElementById( "cus_acct_status" ).value;

						switch( event.target.id ) {
							case "acctStatusActive":
								acctStatus = "A";
								break;
							case "acctStatusInactive":
								acctStatus = "I";
								break;
							case "acctStatusSuspended":
								acctStatus = "S";
								break;
							case "acctStatusUnder":
								acctStatus = "U";
								break;
							default:
								break;
						}

						document.getElementById( "cus_acct_status" ).value = acctStatus;
					});

					//- Select menu style
					jQuery( "#acctStyle_0, #acctStyle_1, #acctStyle_2" ).on( "click tap", function( event ) {
						event.stopImmediatePropagation();
						Utl.appLogger( "acct style click event: ", event );
						Utl.appLogger( "acct style clicked: ", event.target.id );

						let acctStyle =  document.getElementById( "cus_bus_template" ).value;

						switch( event.target.id ) {
							case "acctStyle_0":
								acctStyle = "0";
								break;
							case "acctStyle_1":
								acctStyle = "1";
								break;
							case "acctStyle_2":
								acctStyle = "2";
								break;
							default:
								acctStyle = "0";
								break;
						}

						if( acctStyle === "2" ) {
							jQuery( "#appCarouselSection" ).slideDown( "slow" );
						} else {
							jQuery( "#appCarouselSection" ).slideUp( "slow" );
						}

						document.getElementById( "cus_bus_template" ).value = acctStyle;
					});

					//- Required field validation
					const reqFields = [	"cus_bus_name", "cus_bus_address", "cus_bus_address_2", "cus_bus_city", "cus_bus_zip", "cus_bus_phone", 
										"cus_first_name", "cus_last_name", "cus_phone", "cus_logo_upload",
										"carousel_upload_img_0", "carousel_upload_img_1", "carousel_upload_img_2", 
										"carousel_upload_img_3", "carousel_upload_img_4", "carousel_upload_img_5" ];
					for( let ndx = 0; ndx < reqFields.length; ndx++ ) {
						jQuery('#' + reqFields[ndx]).on('cut paste keyup change', function (e) {
							Utl.appLogger( "cut paste keyup event: ", e );
							let custForm = document.querySelector( "#appAcctProfileForm" );
							custForm.dataset.modified = true;

							//- Clear field on Esc
							if (e.which === 27)
								this.value = "";

							setTimeout(function() {
								if( validateCustomerForm( Utl ) ) {
									document.getElementById( "appSubmitBtn" ).classList.remove("disabled");
								} else {
									document.getElementById( "appSubmitBtn" ).classList.add("disabled");
								}
							}, 100);
						});
					}

					document.getElementById("cus_bus_name").focus();
					document.dispatchEvent(readyEvent);
					clearInterval(timerId);
				}

			}, 100);
		}
		//------------------

		const updateRecord = () => {
			const DataTable = jQuery( '#' + acctTable ).DataTable();		//- Store DataTable
			//- Set field values
			const monTime = ( document.getElementById( "bus_hours_mon" ).checked ? document.getElementById( "mon_time_from" ).value + ";" + document.getElementById( "mon_time_to" ).value : "" );
			const tueTime = ( document.getElementById( "bus_hours_tue" ).checked ? document.getElementById( "tue_time_from" ).value + ";" + document.getElementById( "tue_time_to" ).value : "" );
			const wedTime = ( document.getElementById( "bus_hours_wed" ).checked ? document.getElementById( "wed_time_from" ).value + ";" + document.getElementById( "wed_time_to" ).value : "" );
			const thuTime = ( document.getElementById( "bus_hours_thu" ).checked ? document.getElementById( "thu_time_from" ).value + ";" + document.getElementById( "thu_time_to" ).value : "" );
			const friTime = ( document.getElementById( "bus_hours_fri" ).checked ? document.getElementById( "fri_time_from" ).value + ";" + document.getElementById( "fri_time_to" ).value : "" );
			const satTime = ( document.getElementById( "bus_hours_sat" ).checked ? document.getElementById( "sat_time_from" ).value + ";" + document.getElementById( "sat_time_to" ).value : "" );
			const sunTime = ( document.getElementById( "bus_hours_sun" ).checked ? document.getElementById( "sun_time_from" ).value + ";" + document.getElementById( "sun_time_to" ).value : "" );

			jQuery( "#cus_bus_hours_mon" ).val( monTime );
			jQuery( "#cus_bus_hours_tue" ).val( tueTime );
			jQuery( "#cus_bus_hours_wed" ).val( wedTime );
			jQuery( "#cus_bus_hours_thu" ).val( thuTime );
			jQuery( "#cus_bus_hours_fri" ).val( friTime );
			jQuery( "#cus_bus_hours_sat" ).val( satTime );
			jQuery( "#cus_bus_hours_sun" ).val( sunTime );

			let uploadSrv = adminDir + "/api/appUpload.php";
			let form = document.querySelector( "#appAcctProfileForm" );
			let formData = new FormData( form );

			formData.set( "cus_bus_phone", Utl.getDigitsOnly( document.getElementById( "cus_bus_phone" ).value ) );		//- Convert business phone to digits
			formData.set( "cus_phone", Utl.getDigitsOnly( document.getElementById( "cus_phone" ).value ) );				//- Convert customer phone to digits

			Utl.appLogger( "formData: ", formData );
			Utl.appBlockUI();

			jQuery.ajax({ 
				url: uploadSrv, 
				type: 'post', 
				data: formData,
				dataType: 'json',
				contentType: false, 
				processData: false, 
				success: function(response){ 
					if(response !== 0){ 
						Utl.appLogger('file uploaded', response); 
					} 
					else{ 
						Utl.appLogger('file not uploaded'); 
					}

					showModal( false );
					DataTable.draw( false );		//- This updates the current page ( not passing the parameter 'false' redraws the entire table and moves to page one)
					Utl.appUnBlockUI();
				}, 
			});
		}

		const accountsTable = jQuery( '#' + acctTable ).DataTable({
			serverSide : true,
			processing : true,
			ajax : {
                url: server,
				type : 'POST',
                data: { "method": 11 },
				"error": function (xhr, error, thrown) {
					Utl.appLogger("AJAX Error: "); Utl.appLogger(xhr); Utl.appLogger(error); Utl.appLogger(thrown);
                }
			},
			columns : [
				{	title: ( language === "en" ? "Edit" : "Editar" ),
					searchable: false,
					orderable: false,
					className:"text-center app-acct-edit-col",
					render: function ( data, type, row, meta ) {
						return("<i class='fas fa-chalkboard-teacher' aria-hidden='true' title='' data-toggle='tooltip' data-placement='bottom'></i>");
					},
				},
				{ title : ( language === "en" ? "Account number" : "Número de Cuenta" ), data : 'cus_account', className : 'app-acct-col' },
				{ title : ( language === "en" ? "Name" : "Nombre" ), data : 'cus_bus_name', className : 'app-acct-col' },
				{ title : ( language === "en" ? 'Address' : "Dirección" ), data : 'cus_bus_address', className : 'app-acct-col' }
			],
			order: [[2, 'asc']],
			language: { 
		    	emptyTable: "<h2>Customers not found</h2>", 
		    	info: ( language === "en" ? "Showing _START_ to _END_ of _TOTAL_ accounts" : "Mostrando _START_ a _END_ de _TOTAL_ cuentas" ),
				search: ( language === "en" ? "Search" : "Buscar" ),
				processing: ( language === "en" ? "Processing" : "Procesando" )
		    },
            initComplete: function(settings, data) {
                Utl.appLogger("Data returned: ", data );
				const appStates = data.states;
				const appFood 	= data.foodTypes;

				localStorage.setItem('appStates', JSON.stringify(appStates));
				localStorage.setItem('appFood', JSON.stringify(appFood));
				document.getElementById( acctTable ).setAttribute( "data-admindir", adminDir );


				if( document.getElementById("appAddIcon") === null ) {											//- Check if the add icon has already been added
					const addTitle = ( language === "en" ? "Add" : "Agregar" );
					jQuery( ".dt-length").append( "<a id='appAddIcon' class='text-dark text-decoration-none' href='javascript:void(0)'><div class='ms-4 d-inline app-add-key'><i class='fas fa-plus-circle me-2'></i>"+addTitle+"</div></a>" );
					jQuery( '<div class="d-inline"><i class="fas fa-file-alt"></i></div>' ).insertBefore( ".dt-length" );
					jQuery( ".dt-length" ).addClass( "d-inline" );
				}

				let lengthTimer = setInterval(function() {
					let dlId = document.getElementsByName("AppAccounTable_length")[0].id;                       //- THIS CHANGES IF TABLE ID CHANGED (i.e. "tableID"_length)
					if( document.querySelector("label[for="+dlId+"]") ) {
						document.querySelector("label[for="+dlId+"]").innerHTML = ( language === "en" ? " entries per page" : " récords por página" );
						clearInterval(lengthTimer);
					}
				}, 100);

				//- Add new customer
				jQuery( "#appAddIcon" ).on( "click tap", function( event ) {
					event.stopImmediatePropagation();
					const imgDir 		= adminDir + samplDir + "/default.png";
					const imgAcctDir	= imageDir;
					const acctData 		= [];
					acctData.cus_bus_carousel_img_0 = "";
					acctData.cus_bus_carousel_img_1 = "";
					acctData.cus_bus_carousel_img_2 = "";
					acctData.cus_bus_carousel_img_3 = "";
					acctData.cus_bus_carousel_img_4 = "";
					acctData.cus_bus_carousel_img_5 = "";

					setModalDialogBox();

					document.addEventListener('modalboxready', function() {
						Utl.appLogger("Add new customer box ready: " );
						document.getElementById("appAcctProfileForm").reset();									//- Reset form data
						document.getElementById( "cus_account" ).value = "";
						jQuery( "#cus_bus_phone" ).mask('(000) 000-0000');
						jQuery( "#cus_phone" ).mask('(000) 000-0000');

						setBusinessHours( language, Utl );
						jQuery( "#appCarouselStyle, #appBusinessLogo" ).addClass( "d-none" );
						document.getElementById("appCarouselSection").style.display = 'none';
						setCarouselImages( acctData, imgDir, imgAcctDir );
						document.getElementById( "acctStyle_0" ).click();

						document.getElementById( "appSubmitBtn" ).classList.add("disabled");					//- Disable submit button

						document.addEventListener('appTabSelected', function( event ) {							//- Check the selected tab
							event.stopImmediatePropagation();
							Utl.appLogger( "appTabSelected: ", event );
							if( event.tabSelected === "options" ) {
								document.getElementById("appCarouselSection").style.display = 'none';			//- We hide carousel images for new accounts
							}
						});


						//- Submit form
						jQuery( "#appSubmitBtn" ).on( "click tap", function( event ) {
							event.stopImmediatePropagation();
							updateRecord();
						});
					});
				});


				//- Edit customer profile
				jQuery('#' + acctTable + ' tbody').on('click tap', 'td.app-acct-edit-col', function ( event ) {
					event.stopImmediatePropagation();

					let searchSrv = adminDir + "/api/appAgent.php";
					let accountTbl = jQuery( '#' + acctTable ).DataTable();
				    let tr = jQuery(this).closest('tr');
				    let row = accountTbl.row( tr );
					let acctData = row.data();
					Utl.appLogger("edit customer data: ", acctData );

					//- Get customer information
					jQuery.ajax({
						url:searchSrv,
						type:'post',
						data: { "method":14, "acct":acctData.cus_account, "lang": language },
						dataType:'json',
						success: function( data ) {
							Utl.appLogger( "Customer get account: ", data );
							acctData = data.customer;
							//const acctImgs = data.images;


							setModalDialogBox();

							document.addEventListener('modalboxready', function() {
								Utl.appLogger( "Modal box ready" );

								document.getElementById("appAcctProfileForm").reset();									//- Reset form data
								document.getElementById("acctStyle_0").click();

								const imgDir 		= adminDir + samplDir + "/default.png";
								const imgAcctDir	= imageDir + "/" + acctData.cus_account;

								setBusinessHours( language, Utl );
								jQuery( "#appCarouselStyle, #appBusinessLogo" ).removeClass( "d-none" );

								const monHrs = ( acctData.cus_bus_hours_mon !== null && acctData.cus_bus_hours_mon !== "" ? acctData.cus_bus_hours_mon.split(";") : [ "", "" ] );
								const tueHrs = ( acctData.cus_bus_hours_tue !== null && acctData.cus_bus_hours_tue !== "" ? acctData.cus_bus_hours_tue.split(";") : [ "", "" ] );
								const wedHrs = ( acctData.cus_bus_hours_wed !== null && acctData.cus_bus_hours_wed !== "" ? acctData.cus_bus_hours_wed.split(";") : [ "", "" ] );
								const thuHrs = ( acctData.cus_bus_hours_thu !== null && acctData.cus_bus_hours_thu !== "" ? acctData.cus_bus_hours_thu.split(";") : [ "", "" ] );
								const friHrs = ( acctData.cus_bus_hours_fri !== null && acctData.cus_bus_hours_fri !== "" ? acctData.cus_bus_hours_fri.split(";") : [ "", "" ] );
								const satHrs = ( acctData.cus_bus_hours_sat !== null && acctData.cus_bus_hours_sat !== "" ? acctData.cus_bus_hours_sat.split(";") : [ "", "" ] );
								const sunHrs = ( acctData.cus_bus_hours_sun !== null && acctData.cus_bus_hours_sun !== "" ? acctData.cus_bus_hours_sun.split(";") : [ "", "" ] );

								if( monHrs[0] !== "" && monHrs[1] !== "" ) {
									document.getElementById( "bus_hours_mon" ).click();
									document.getElementById("mon_time_from").value = monHrs[0];
									document.getElementById("mon_time_to").value = monHrs[1];
								}

								if( tueHrs[0] !== "" && tueHrs[1] !== "" ) {
									document.getElementById( "bus_hours_tue" ).click();
									document.getElementById("tue_time_from").value = tueHrs[0];
									document.getElementById("tue_time_to").value = tueHrs[1];
								}

								if( wedHrs[0] !== "" && wedHrs[1] !== "" ) {
									document.getElementById( "bus_hours_wed" ).click();
									document.getElementById("wed_time_from").value = wedHrs[0];
									document.getElementById("wed_time_to").value = wedHrs[1];
								}

								if( thuHrs[0] !== "" && thuHrs[1] !== "" ) {
									document.getElementById( "bus_hours_thu" ).click();
									document.getElementById("thu_time_from").value = thuHrs[0];
									document.getElementById("thu_time_to").value = thuHrs[1];
								}

								if( friHrs[0] !== "" && friHrs[1] !== "" ) {
									document.getElementById( "bus_hours_fri" ).click();
									document.getElementById("fri_time_from").value = friHrs[0];
									document.getElementById("fri_time_to").value = friHrs[1];
								}

								if( satHrs[0] !== "" && satHrs[1] !== "" ) {
									document.getElementById( "bus_hours_sat" ).click();
									document.getElementById("sat_time_from").value = satHrs[0];
									document.getElementById("sat_time_to").value = satHrs[1];
								}

								if( sunHrs[0] !== "" && sunHrs[1] !== "" ) {
									document.getElementById( "bus_hours_sun" ).click();
									document.getElementById("sun_time_from").value = sunHrs[0];
									document.getElementById("sun_time_to").value = sunHrs[1];
								}

								//- Set account status
								let acctStatus = "U";

								switch( acctData.cus_acct_status ) {
									case "A":
										document.getElementById( "acctStatusActive" ).click();
										acctStatus = "A";
										break;
									case "I":
										document.getElementById( "acctStatusInactive" ).click();
										acctStatus = "I";
										break;
									case "S":
										document.getElementById( "acctStatusSuspended" ).click();
										acctStatus = "S";
										break;
									case "U":
										document.getElementById( "acctStatusUnder" ).click();
										acctStatus = "U";
										break;
									default:
										document.getElementById( "acctStatusUnder" ).click();
										break;
								}

								//- Business information
								jQuery( "#cus_acct_status" ).val( acctStatus );
								jQuery( "#cus_account" ).val( acctData.cus_account );
								jQuery( "#cus_bus_name" ).val( acctData.cus_bus_name );
								jQuery( "#cus_bus_address" ).val( acctData.cus_bus_address );
								jQuery( "#cus_bus_address_2" ).val( acctData.cus_bus_address_2 );
								jQuery( "#cus_bus_city" ).val( acctData.cus_bus_city );
								jQuery( "#cus_bus_state" ).val( acctData.cus_bus_state );
								jQuery( "#cus_bus_zip" ).val( acctData.cus_bus_zip );
								jQuery( "#cus_bus_phone" ).val( acctData.cus_bus_phone );
								jQuery( "#cus_bus_phone" ).mask('(000) 000-0000');
								jQuery( "#cus_bus_food_type" ).val( acctData.cus_bus_food_type );
								jQuery( "#cus_logo" ).val( acctData.cus_logo );
								jQuery( "#cus_logo_saved" ).val( acctData.cus_logo );
								jQuery( "#cus_bus_web_address" ).val( acctData.cus_bus_web_address );
								jQuery( "#cus_bus_desc_en" ).val( acctData.cus_bus_desc_en );
								jQuery( "#cus_bus_desc_es" ).val( acctData.cus_bus_desc_es );

								//- Customer information
								jQuery( "#cus_first_name" ).val( acctData.cus_first_name );
								jQuery( "#cus_last_name" ).val( acctData.cus_last_name );
								jQuery( "#cus_address" ).val( acctData.cus_address );
								jQuery( "#cus_city" ).val( acctData.cus_city );
								jQuery( "#cus_state" ).val( acctData.cus_state );
								jQuery( "#cus_zip" ).val( acctData.cus_zip );
								jQuery( "#cus_phone" ).val( acctData.cus_phone );
								jQuery( "#cus_phone" ).mask('(000) 000-0000');

								//- Menus information (TODO)



								//- Options
								//- Social media
								jQuery( "#cus_bus_facebook" ).val( acctData.cus_bus_facebook );
								jQuery( "#cus_bus_twitter" ).val( acctData.cus_bus_twitter );
								jQuery( "#cus_bus_instagram" ).val( acctData.cus_bus_instagram );
								jQuery( "#cus_bus_youtube" ).val( acctData.cus_bus_youtube );

								//- Menu style
								let acctStyle = "acctStyle_0";
								switch( acctData.cus_bus_template ) {
									case "0": acctStyle = "acctStyle_0";
										break;
									case "1": acctStyle = "acctStyle_1";
										break;
									case "2": acctStyle = "acctStyle_2";
										break;
									default:
										break;
								}
								
								let styleTimer = setInterval(function() {
									document.getElementById( acctStyle ).click();
									clearInterval( styleTimer );
								}, 250);

								jQuery( "#cus_bus_template" ).val( acctData.cus_bus_template );

								//- Carousel images
								setCarouselImages( acctData, imgDir, imgAcctDir );

								jQuery( "#carousel_img_0" ).attr( "src", imgAcctDir + "/" + acctData.cus_bus_carousel_img_0 );
								jQuery( "#carousel_img_1" ).attr( "src", imgAcctDir + "/" + acctData.cus_bus_carousel_img_1 );
								jQuery( "#carousel_img_2" ).attr( "src", imgAcctDir + "/" + acctData.cus_bus_carousel_img_2 );
								jQuery( "#carousel_img_3" ).attr( "src", imgAcctDir + "/" + acctData.cus_bus_carousel_img_3 );
								jQuery( "#carousel_img_4" ).attr( "src", imgAcctDir + "/" + acctData.cus_bus_carousel_img_4 );
								jQuery( "#carousel_img_5" ).attr( "src", imgAcctDir + "/" + acctData.cus_bus_carousel_img_5 );

								const selBtn = [];
								const selImg = [];

								for( let img = 0; img < 6; img++ ) {
									selBtn[img] = document.getElementById( "carousel_from_computer_" + img );
									selImg[img] = document.getElementById( "carousel_upload_img_" + img );

									if( selBtn[img] ) {
										selBtn[img].addEventListener(
											"click",
											(event) => {
												event.stopImmediatePropagation();
												if ( selImg[img] ) {
													selImg[img].click();
												}
											},
											false,
										);

										selImg[img].addEventListener(
											"change",
											(event) => {
												Utl.appLogger( "carousel img change event: ", event );
												const imageId = event.target.id;
												const imgIndex = imageId.slice(-1);
												const thisImgFile = "cus_bus_carousel_img_" + imgIndex;

												let files = jQuery( '#' + imageId )[0].files[0]; 
						  						Utl.appLogger( "Image File: ", files );
						  
						  						if( files.size > MAX_UPLOAD_FILE_SIZE || files.name.length > MAX_UPLOAD_FILE_NAME ) {
													document.getElementById( "carousel_upload_img_" + imgIndex ).value = "";

													const isTooBig = ( files.size > MAX_UPLOAD_FILE_SIZE ? true : false );
													const uploadFileBig = ( language === "en" ? "This file size is too big.  Maximum size is 5 megabytes." : "El tamaño de este archivo es muy grande.  El tamaño máximo es de 5 megabytes." );
													const uploadNameBig = ( language === "en" ? "This file name size is too big.  Maximum file name size is 32 characters." : "El nombre de este archivo es muy grande.  El tamaño máximo del nombre es de 32 bytes." );
													
													const dlgId 		= modalBodyId;
													const dlgSize		= "md";
													const dlgTitle 		= ( language === "en" ? "File too big" : "Archivo muy grande" );
													const dlgMessage 	= ( isTooBig ? uploadFileBig : uploadNameBig );

													Utl.appLogger( ( isTooBig ? "File size of " + files.size : "File name size of " + files.name.length ) + " is too big!" );
													showMessageDlg( dlgId, dlgSize, dlgTitle, dlgMessage );
													return( false );
												}

												//- Read pre-uploaded file contents and show image
												const input  = event.target;
												const reader = new FileReader();

												reader.onload = function(){
													let dataURL = reader.result;
													let output = document.getElementById( 'carousel_img_' + imgIndex );
													//document.getElementById( "cus_bus_carousel_img_" + imgIndex ).value = dataURL;
													//document.getElementById( "cus_bus_carousel_img_" + imgIndex ).value = files.name;
													document.getElementById( "cus_bus_carousel_img_" + imgIndex ).value = "cus_bus_carousel_img_" + imgIndex + ".jpg";
													output.src = dataURL;
												};
												reader.readAsDataURL(input.files[0]);

												


												/*
												document.getElementById( "current_carousel_img" ).value = imageId;

												let uploadSrv = adminDir + "/api/appUploadCarousel.php";
												let form = document.querySelector( "#appAcctProfileForm" );
												let formData = new FormData( form );

												jQuery.ajax({ 
													url: uploadSrv, 
													type: 'post', 
													data: formData,
													dataType: 'json',
													contentType: false, 
													processData: false, 
													success: function(response){ 
														Utl.appLogger( "Response: ", response );
														Utl.appLogger( "Status: ", response.status );
														Utl.appLogger( "uploadedFile: ", response.uploadedFile );
														if( response.status ){ 
															const uploadedFileName = imgAcctDir + "/" + thisImgFile + ".jpg?" + new Date().getTime();
															Utl.appLogger('Carousel file uploaded', response);
															document.getElementById( thisImgFile ).value = thisImgFile + ".jpg";
															jQuery( "#" + imageId ).val("");
															jQuery( "#carousel_img_" + imgIndex ).attr( "src", uploadedFileName );
														} 
														else{ 
															Utl.appLogger('Carousel file not uploaded'); 
														} 
													}, 
												});
												*/
											}
										);
									}
								}

								
								//- Submit form
								jQuery( "#appSubmitBtn" ).on( "click tap", function( event ) {
									event.stopImmediatePropagation();
									updateRecord();
								});

								document.getElementById( "appSubmitBtn" ).classList.add("disabled");			//- Disable submit button
							});
						},
						error: function(  jqXHR, textStatus, errorThrown  ){
							var errMsg = 'Customer get account network failure: '+textStatus+" ("+errorThrown+")";
							Utl.appLogger( errMsg );
						},
						complete: function(){
							Utl.appLogger( "Customer get account completed" );
						}
					});









					








				});


				//- Show profile details
				jQuery( '#' + acctTable + ' tbody').on('click tap', 'td.app-acct-col', function ( event ) {
					event.stopImmediatePropagation();
					Utl.appLogger( "Acct Edit event: ", event );

					

					

				});

            }
		});

		return () => {
			accountsTable.destroy();
		};

	}, []);

	return (
		<>
		
		<div className="container-fluid">
			<h1 className="mt-5 mb-5 text-center">
				<b>
					<FormattedMessage
                        id = "app-dash-accounts"
                        defaultMessage="Accounts"
                    />
				</b></h1>
			<div className="card">
				<div className="card-header">
					<FormattedMessage
                        id = "app-customer-accounts"
                        defaultMessage="Customer Accounts"
                    />
				</div>
				<div className="card-body">
					<table className="table table-bordered table-striped display table-hover" id={acctTable}>
						<thead>
							<tr>
								<th>Edit</th>
								<th>ID</th>
          						<th>Name</th>
          						<th>Email</th>
							</tr>
						</thead>
						<tbody></tbody>
					</table>
				</div>
			</div>
		</div>
		{show &&
			createPortal( <ModalBox 
							show={true} 
							onExit={handleModalExit} 
							onTabSelect={onTabSelect}
							showTabs={true} 
							tabKey={tabKey}
							title={modalTitle} 
							submit={true} 
							size={modalSize} 
							closeBtn={language === 'es' ? "Cierre" : "Close"} 
							submitBtn={language === 'es' ? "Actualizar" : "Submit"} 
							/>, document.body )
		 }
		 {showMsg &&
			createPortal( <ModalBox 
							show={true} 
							onExit={handleModalMsgExit} 
							showTabs={false} 
							title={modalMsgTitle} 
							submit={true} 
							size={modalMsgSize} 
							closeBtn={language === 'es' ? "Cierre" : "Close"} 
							submitBtn={language === 'es' ? "Actualizar" : "Submit"} 
							submitBtnId={submitBtnId}
							appCloseBtn={appCloseBtn}
							modalMsgsId={modalMsgsId}
							modalBodyId={modalBodyId}
							modalTitleId={modalTitleId}
							modalBoxId={modalBoxId}
							/>, document.body )
		 }
		 
		</>
	);
};

export default AccounTable;